export interface ExpenseTravelConstructor {
  id: number
  uuid: string
  purpose: string
}

export class ExpenseTravel {
  readonly id: number
  readonly uuid: string
  readonly purpose: string

  constructor(data: ExpenseTravelConstructor) {
    this.id = data.id
    this.uuid = data.uuid
    this.purpose = data.purpose || ''
  }
}
